/* Salt Rips Now v4-148: shared customer-account status in global header.
   Use the same verified customer-account token and profile proxy as Collector Hub.
   Never trust customer identity from unverified browser storage. */
(()=>{'use strict';
 const bar=document.getElementById('srnGlobalAccount');if(!bar)return;
 const loading=bar.querySelector('[data-srn-account-loading]');
 const member=bar.querySelector('[data-srn-account-member]');
 const guest=bar.querySelector('[data-srn-account-guest]');
 const name=bar.querySelector('[data-srn-account-name]');
 const nav=document.querySelector('[data-srn-account-nav]');
 let epoch=0;
 function display(ok,firstName){loading.hidden=true;member.hidden=!ok;guest.hidden=ok;if(nav)nav.hidden=!ok;
   name.textContent=ok?(firstName||'Collector'):'';
 }
 function token(){try{const item=JSON.parse(sessionStorage.getItem('srn-collector-token-v91')||'null');
   return item?.access_token&&Number(item.expires_at)>Date.now()+20000?item.access_token:null;
 }catch{return null}}
 async function refresh(){const version=++epoch,access=token();if(!access){display(false);return}
   try{const response=await fetch('/apps/collector-profile',{method:'POST',headers:{'Content-Type':'application/json'},
     cache:'no-store',body:JSON.stringify({action:'load',customer_access_token:access})});
     const data=await response.json().catch(()=>({}));if(version!==epoch)return;
     if(response.ok&&(data.loaded===true||data.read_permission_needed===true)){
       const full=(data.first_name||data.firstName||'').trim();display(true,full);
     }else{if(response.status===401||response.status===403){try{sessionStorage.removeItem('srn-collector-token-v91')}catch{}}display(false)}
   }catch{if(version===epoch)display(false)}
 }
 bar.querySelector('[data-srn-global-logout]')?.addEventListener('click',()=>{
   try{sessionStorage.removeItem('srn-collector-token-v91')}catch{}
 });
 window.addEventListener('pageshow',refresh);
 window.addEventListener('focus',refresh);
 window.addEventListener('srn:collector-auth',refresh);
 refresh();
})();
